"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GraphqlError = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _ExtendedAxiosError = require("./ExtendedAxiosError");
/**
 * Generic error caused by failed call to the graphql server
 */
class GraphqlError extends _ExtendedAxiosError.ExtendedAxiosError {
  constructor(axiosError) {
    super(axiosError);
    (0, _defineProperty2.default)(this, "graphqlVariables", void 0);
    (0, _defineProperty2.default)(this, "graphqlQuery", void 0);
    this.name = 'GraphqlError';
    const {
      config
    } = axiosError;
    let data = null;
    try {
      if (typeof config?.data === 'object') {
        data = config.data;
      } else if (typeof config?.data === 'string') {
        data = JSON.parse(config.data);
      }
    } catch {
      // If we cannot parse the data, we just ignore it
      // This is usually the case when the data is not JSON, but some other format
    }
    this.graphqlVariables = data?.variables ?? null;
    this.graphqlQuery = data?.query ?? null;
  }
}
exports.GraphqlError = GraphqlError;
//# sourceMappingURL=GraphqlError.js.map